
<template>
  <div class="payment-success">
      <h1>お支払いありがとうございます！お手続きが完了しました。</h1>
      <button class="home-btn btn-comp" v-on:click="goHome()">ログイン</button>
  </div>
</template>

<style scoped>
  .payment-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  .btn-comp {
    color: white;
    border: none;
    border-radius: 30px;
    width: 80%;
    max-width: 300px;
    margin-top: 30px;
    padding: 12px;
    font-size: 1.2rem;
    font-weight: 900;
  }

  .home-btn {
    background: rgb(248, 70, 129);
    background: linear-gradient(90deg, rgba(248, 70, 129, 1) 0%, rgba(255, 150, 145, 1) 100%);
  }
</style>

<script>
export default {
  name: 'PaymentSuccess',
  methods: {
    goHome() {
      this.$router.push('/');
    }
  }
};
</script>